export default __webpack_public_path__ + "static/media/ic_agreement.1cbab2db.svg";